// **React Imports
import { memo } from 'react'

// **MUI Imports
import { Box, Button, Typography } from '@mui/material'

const ToastContent = ({
  closeToast = () => {},
  retryAction = () => {},
  description
}) => {
  return (
    <Box sx={{ px: 1 }}>
      <Box
        sx={{
          display: 'flex',
          gap: '12px',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          mb: 1
        }}
      >
        <Typography variant="subtitle1" fontWeight="bold">
          New Notification
        </Typography>
        <Button
          size="small"
          variant="contained"
          onClick={() => {
            retryAction?.()
            closeToast?.()
          }}
        >
          View{' '}
        </Button>
      </Box>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {description}
      </Typography>
    </Box>
  )
}

export default memo(ToastContent)
